var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15184_3966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1325 16.3214C16.1323 16.323 16.1318 16.3258 16.1312 16.3299C16.7716 16.4335 22.4421 17.4039 25.9498 19.7953C26.5023 20.061 27.025 20.4266 27.489 20.8906C29.5296 22.9312 29.6652 26.1039 27.7919 27.9772C25.9186 29.8505 22.7458 29.7149 20.7053 27.6744C20.4322 27.4012 20.1932 27.1078 19.9885 26.7999C17.3968 23.5381 16.2926 17.626 16.1022 16.5062C15.9225 17.5633 14.9308 22.8767 12.6467 26.2143C12.3816 26.7607 12.0188 27.2774 11.5595 27.7368C9.51893 29.7773 6.34616 29.9129 4.47289 28.0396C2.59961 26.1663 2.7352 22.9936 4.77573 20.953C5.05526 20.6735 5.35605 20.4297 5.67183 20.2219C8.9463 17.6337 14.8613 16.5344 15.956 16.3488C14.8613 16.1632 8.9463 15.0638 5.67183 12.4756C5.35605 12.2679 5.05526 12.0241 4.77573 11.7445C2.7352 9.70402 2.59961 6.53125 4.47288 4.65798C6.34616 2.7847 9.51893 2.92029 11.5595 4.96082C12.0188 5.42018 12.3816 5.93692 12.6467 6.4833C15.0501 9.99519 16.0226 15.6948 16.1238 16.3213C16.1277 16.3207 16.1303 16.3203 16.1317 16.32C16.1487 16.2095 17.0949 10.1133 19.6175 6.42718C19.8826 5.8808 20.2454 5.36406 20.7047 4.9047C22.7453 2.86417 25.918 2.72858 27.7913 4.60186C29.6646 6.47513 29.529 9.6479 27.4885 11.6884C27.2089 11.968 26.9081 12.2118 26.5924 12.4195C23.0001 15.2589 16.2298 16.3065 16.1325 16.3214Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15184_3966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7032,
    height: 31.7032,
    fill: "white",
    transform: "translate(0.3125 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape5);
export default __webpack_public_path__ + "static/media/shape5.0a86acbb72349efc118d0fe0e58989c5.svg";
export { ForwardRef as ReactComponent };